// extracted by mini-css-extract-plugin
export default {"wrapperComponent":"Pagination_wrapperComponent__aUBzD","list":"Pagination_list__lG2Dg","selected":"Pagination_selected__MzOak"};